import React, { useState, useRef, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import { useKonami } from 'react-konami-code';
import Nav from '../components/Nav.js';
import Masthead from '../components/Masthead/index.js';
import ModalOverlay from '../components/ModalOverlay';
import HomeMap from '../components/Home/map';
import Grant from '../components/Home/Grant';
import { GAfirePageView } from '../components/Tracking';
import Disclaimers from '../components/Disclaimers.js';
import Footer from '../components/Footer';

import Observer from 'react-intersection-observer';


import 'wicg-inert'
import ScrollToTop from "../libs/scrollToTop";
import { isEs } from "../libs/lang";

import { fireTag } from '../libs/analytics.js';

const Home = ({
	uiState,
	activePage,
	isMobile,
	handleEvent,
	resetMap,
	chooseDropdownType,
	mapLoading,
	alreadyShown,
	location,
	results,
	checkForCityOrZip,
	goToAnchor,
	closeExitOverlay,
	addExitClickListeners,
	displayModalOverlay,
	modalOverlay,
}) => {
	const NRef = useRef(null);


	/**
	 * Native scrollTo with callback
	 * @param offset - offset to scroll to
	 * @param callback - callback function
	 */

	// const enableScrollGA = true;

	const image = isEs() ? "https://welcome.wf.com/impact/images/default-share-es.jpg" : "https://welcome.wf.com/impact/images/default-share.jpg";

	const [gridVisible, setGridVisible] = useState(false);
	const [enableScrollGA, setEnableScrollGA] = useState(false);
	const [shouldBeInert, setShouldBeInert] = useState(false);
	const toggleInert = () => {
		setShouldBeInert(!shouldBeInert)
	}

	//GAfirePageView();
	addExitClickListeners();

	useEffect(() => {
		// console.log(`To see grid overlay, type ↑ ↑ ↓ ↓ ← → ← → B A inside the browser window`);
		ScrollToTop(setEnableScrollGA)
	}, []);
	const toggleGrid = () => {
		const grid = document.getElementsByClassName('grid')[0];
		grid.style.display = (!gridVisible) ? 'none' : 'block';
		setGridVisible(!gridVisible)
	}

	const KonamiElement = () => {
		useKonami(toggleGrid, {
			code: [37, 39, 37, 39]
		});
		return <div className="grid" style={{ display: gridVisible ? 'block' : 'none' }} />;
	};

	return (
		<>
			<Helmet>
				<html lang={isEs() ? 'es' : 'en'} />
				<title>{isEs() ? 'El banco para ir con todo | Wells Fargo' : 'The Bank of Doing | Wells Fargo'}</title>
				<link rel="canonical" href="https://welcome.wf.com/impact/" />
				<meta
					name="robots"
					content={location.search.indexOf('target=district') > -1 ? 'noindex, nofollow' : 'index, follow'}
				/>
				<meta
					name="description"
					content={isEs() ? "Haciendo, fortalecemos comunidades al apoyar a pequeñas empresas, financiar becas, hacer viviendas más asequibles, e tomar acción en el cambio climático. »"
						: "Doing makes our communities stronger, by supporting small businesses, funding scholarships, making housing more attainable, and taking action on climate. »"}
				/>
				<meta property="image" content={`${image}`} />
			</Helmet>
			<Nav isNotHomePage={false} activePage={activePage}
				handleEvent={handleEvent}
				isMobile={isMobile}
				forwardedRef={NRef}
				shouldBeInert={shouldBeInert}
				toggleInert={toggleInert}
			/>
			<main ref={node => node && (shouldBeInert ? node.setAttribute('inert', '') : (node.removeAttribute('inert')))}>
				<Masthead
					enableScrollGA={enableScrollGA}
					styles="home"
					goToAnchor={goToAnchor}
					displayModalOverlay={displayModalOverlay}
					shouldBeInert={shouldBeInert}
					activePage={activePage}
				/>
				<HomeMap
					enableScrollGA={enableScrollGA}
					shouldBeInert={shouldBeInert}
					uiState={uiState}
					handleEvent={handleEvent}
					resetMap={resetMap}
					chooseDropdownType={chooseDropdownType}
					mapLoading={mapLoading}
					alreadyShown={alreadyShown}
					location={location}
					results={results}
					checkForCityOrZip={checkForCityOrZip}

				/>
				<Grant
					enableScrollGA={enableScrollGA}
					shouldBeInert={shouldBeInert}
				/>
				<Disclaimers goToAnchor={goToAnchor} route="home"
					shouldBeInert={shouldBeInert}
				/>
				{/*<KonamiElement className="grid"/>*/}
			</main>

			<Footer id="footer" footerStyles="global" shouldBeInert={shouldBeInert} activePage={activePage} enableScrollGA={enableScrollGA} />

			<div className="nav-overlay mobile-only" style={{ display: 'none' }} ref={node => node && (shouldBeInert ? node.setAttribute('inert', '') : (node.removeAttribute('inert')))} />

			{modalOverlay && modalOverlay.open && (<ModalOverlay closeExitOverlay={closeExitOverlay} modalOverlay={modalOverlay} ref={node => node && (shouldBeInert ? node.setAttribute('inert', '') : (node.removeAttribute('inert')))} />)}
		</>
	);
};

export default withRouter(Home);
